export class RatingConstants {
  static DEFAULT_MAX_STARS = 5;
  static DEFAULT_FONT_SIZE = 18;
}
